module.exports = __webpack_public_path__ + "static/media/admin.02b676a5.png";